// @flow

import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { RequiresSignInErrorName } from 'services/auth'

export default function useAuthRequest<Tin, Tout>(
  callback: (Tin) => Promise<Tout>
): (Tin) => Promise<Tout> {
  const history = useHistory()

  return React.useCallback(
    async (...props) => {
      try {
        return await callback(...props)
      } catch (error) {
        if (error.name === RequiresSignInErrorName) {
          history.replace('/login')
          // $FlowFixMe
          return
        }
        throw error
      }
    },
    [callback, history]
  )
}
